const apiValidation = (apiData) => {
  const data = {
    message: '',
    error: false
  }

  if (apiData.error) {
    return {
      message: '',
      error: true
    }
  }
  return data
}

const apiError500 = () => {
  return {
    message: 'Error 500 de conexión consulte con el administrador',
    error: true,
    variant: 'error'
  }
}

const getHttpError = (statusCode) => {
  const errors = {
    200: {
      message: 'Servicio respondió.',
      error: false,
      variant: 'success'
    },
    400: {
      message: 'Solicitud incorrecta. Verifique los datos enviados.',
      error: true,
      variant: 'error'
    },
    401: {
      message: 'No autorizado. Verifique sus credenciales.',
      error: true,
      variant: 'error'
    },
    403: {
      message: 'Acceso prohibido. No tiene permisos suficientes.',
      error: true,
      variant: 'error'
    },
    404: {
      message: 'Recurso no encontrado. Verifique la URL.',
      error: true,
      variant: 'error'
    },
    408: {
      message: 'Tiempo de espera agotado. Intente nuevamente.',
      error: true,
      variant: 'error'
    },
    500: {
      message: 'Error interno del servidor. Consulte con el administrador.',
      error: true,
      variant: 'error'
    },
    503: {
      message: 'Servicio no disponible. Intente más tarde.',
      error: true,
      variant: 'error'
    },
    default: {
      message: 'Error desconocido. Intente nuevamente o contacte al soporte.',
      error: true,
      variant: 'error'
    }
  }
  return errors[statusCode] || errors.default
}

const exportValidations = {
  apiValidation,
  apiError500,
  getHttpError
}

export default exportValidations
